module.exports = __webpack_public_path__ + "static/img/advantage3.d9f1c347.png";